import React from "react";
import { connect } from "react-redux";

import {
  doUpdateRoutePlan,
  doDetailRoutePlan,
  doAddOrdersRoutePlan,
  doRemoveOrdersRoutePlan,
  doAddDriversRoutePlan,
  doRemoveDriversRoutePlan,
  doOptimizeRoutePlan,
  doReorderRoute,
  doDispatchRoutePlan,
  doLockDriver,
  doEditDriver,
  doSwapOrdersToDriver,
  doDuplicateRoutePlan,
} from "../stores/thunk";

import { handleFailedOptimize, handleFetching } from "../stores/slice";

import { doGetAllOrders, doUploadOrders } from "../../order/stores/thunk";
import { selectAllOrders } from "../../order/stores/slice";

import { doCreateDriver, doGetAllDrivers } from "../../driver/stores/thunk";
import { selectAllDrivers } from "../../driver/stores/slice";

export default Component => {
  class Container extends React.Component {
    componentDidMount() {
      const { id, doDetailRoutePlan } = this.props;
      if (id) {
        doDetailRoutePlan(id);
      }
    }
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state, props) {
    const { match } = props;
    const params = match.params;
    return {
      isFetching: state.routePlan.isFetching || state.order.isFetching || state.driver.isFetching,
      id: params.id,
      type: params.type,
      routePlan: state.routePlan.item,
      user: state.auth.user,
      orders: selectAllOrders(state),
      metadataOrders: state.order.metadata,
      drivers: selectAllDrivers(state),
      metadataDrivers: state.driver.metadata,
    };
  }

  return connect(mapStateToProps, {
    doUpdateRoutePlan,
    doDetailRoutePlan,
    doAddOrdersRoutePlan,
    doCreateDriver,
    doRemoveOrdersRoutePlan,
    doAddDriversRoutePlan,
    doRemoveDriversRoutePlan,
    doDuplicateRoutePlan,
    doUploadOrders,
    doGetAllOrders,
    doGetAllDrivers,
    doOptimizeRoutePlan,
    doReorderRoute,
    doDispatchRoutePlan,
    doLockDriver,
    doEditDriver,
    doSwapOrdersToDriver,
    handleFailedOptimize,
    handleFetching,
  })(Container);
};
